/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-19 11:31:30
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-19 18:06:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/Components/TimeOrderedList/tool.ts
 */
import moment from 'moment';
import { generateMomentTime } from 'src/tools/tools';
export const processingList = (
  orderedByTime: boolean,
  timePropertyName: {
    startTime: string;
    startDate: string;
    endTime: string;
    endDate: string;
  },
  customOrderFunc: (list: Array<any>) => {
    Active: Array<any>;
    Pending: Array<any>;
    Previous: Array<any>;
  },
  list: Array<any>,
  scTimezoneUTC: string,
) => {
  const Active = [];
  const Pending = [];
  const Previous = [];
  const now = moment().tz(scTimezoneUTC);

  if (orderedByTime) {
    list.forEach((setting, index) => {
      const startTime = setting[timePropertyName.startTime];
      const startDate = setting[timePropertyName.startDate];
      const endTime = setting[timePropertyName.endTime];
      const endDate = setting[timePropertyName.endDate];
      const start = generateMomentTime(startDate, startTime, scTimezoneUTC);
      const end = generateMomentTime(endDate, endTime, scTimezoneUTC);
      const _setting = {
        ...setting, //__originalIndex: index
      };
      if (!start.isValid() || !end.isValid()) Pending.push(_setting);
      else {
        if (now.isBetween(start, end)) Active.push(_setting);
        if (now.isAfter(end)) Previous.push(_setting);
        if (now.isBefore(start)) Pending.push(_setting);
      }
    });
    return {
      Active,
      Pending,
      Previous,
    };
  } else {
    return customOrderFunc(list);
  }
};

// export const generateMomentTime = (
//   date: string,
//   time: string,
//   timezone: string,
// ) => {
//   if (!date) {
//     return moment('invalid date');
//   } else {
//     const dateString = `${date} ${time}`;
//     return moment.tz(dateString, timezone);
//   }
// };
